import React from "react";
import { GenericDialog, GenericDialogContent, GenericDialogHeader } from "../../../../../../common/components";
import AICreationContent from "./AICreationContent";
import styles from "./AiCreationDialog.module.css";
import { translate } from "../../../../../../common/providers";

const AiCreationDialog = ({ open, onClose, onSubmit }) => {
	const handleSubmit = (props) => {
		onSubmit(props);
		onClose();
	};

	return (
		<GenericDialog className={styles.dialog} open={open} onClose={onClose}>
			<GenericDialogHeader>
				<div>{translate("notes.new-note.ai-creation-dialog.header")}</div>
			</GenericDialogHeader>
			<GenericDialogContent className={styles.content}>
				<AICreationContent onSubmit={handleSubmit} />
			</GenericDialogContent>
		</GenericDialog>
	);
};

export default AiCreationDialog;
